import styled from "@emotion/styled";

import { colors } from "../../colors";
import { getRadioStyles } from "./radio-styles";
import type { RadioStyleProps, StyledRadioProps } from "./types";

export const Container = styled.label<{
  $labelPosition: "left" | "right";
  $disabled?: boolean;
  $styleProps?: RadioStyleProps;
}>`
  display: inline-flex;
  align-items: center;
  gap: ${({ $styleProps }) => $styleProps?.spacing || "8px"};
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  flex-direction: ${({ $labelPosition }) =>
    $labelPosition === "left" ? "row-reverse" : "row"};
`;

export const LabelContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const LabelText = styled.span<{
  $disabled?: boolean;
  $styleProps?: RadioStyleProps;
}>`
  font-weight: ${({ $styleProps }) => $styleProps?.labelFontWeight || "500"};
  font-size: ${({ $styleProps }) => $styleProps?.labelFontSize || "1em"};
  color: ${({ $styleProps, $disabled }) => {
    if ($disabled) {
      return $styleProps?.labelColor
        ? `${$styleProps.labelColor}66`
        : colors.gray[400];
    }
    return $styleProps?.labelColor || colors.gray[800];
  }};
`;

export const Description = styled.span<{
  $disabled?: boolean;
  $styleProps?: RadioStyleProps;
}>`
  font-size: ${({ $styleProps }) =>
    $styleProps?.descriptionFontSize || "0.9em"};
  color: ${({ $styleProps, $disabled }) => {
    if ($disabled) {
      return $styleProps?.descriptionColor
        ? `${$styleProps.descriptionColor}40`
        : colors.gray[300];
    }
    return $styleProps?.descriptionColor || colors.gray[500];
  }};
`;

export const VisualWrapper = styled.span`
  position: relative;
  display: inline-block;
`;

export const RadioButton = styled.div<StyledRadioProps>`
  ${({ $size, $checked, $disabled, $styleProps }) =>
    getRadioStyles($size, $checked, $disabled, $styleProps)}
`;

export const HiddenInput = styled.input`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
`;
